<script lang="ts">

    import ReviewStars from "./ReviewStars.svelte";
    import Link from "./Link.svelte";
    export let stars : any
    export let heading  : string
    export let content : string
    export let author : string
    export let reviewLink : string

</script>

<div class="review-card">

    <div class="review-card__stars">
        <ReviewStars {stars}/>
    </div>
    <h3 class="review-card__heading">"{heading}"</h3>
    <p class="review-card__content">{content}</p>
    <span class="review-card__author">{author}</span>
    <Link linkText="Read more" link={reviewLink} showArrow={true}/>
</div>

<style lang="postcss">

@import '../../../src/styles/_mixins.css';

.review-card {

    display: flex;
    flex-direction: column;
    border:solid 3px var(--color_offerzen_navy);
    padding:24px;
    border-radius:8px;
    transition: transform .2s;
    @mixin boxShadow;

    & .review-card__heading {
       color:var(--color_offerzen_navy);
       font-size:18px;
       line-height:24px;
       margin:10px 0;
    }

    & .review-card__content {
        margin:0 0 8px;
        font-size:16px;
        line-height:140%;
        color:var(--color_grey_four);
    }

    & .review-card__author {
        font-weight:600;
        color:var(--color_grey_four);
        margin:0 0 16px;
        font-size:14px;
    }

    &:hover {
        transform: scale(1.03);
    }
 }


</style>